import { Form } from 'antd';
import { RevxRadio } from 'components';
import {
  JobconfigBindingPerfectBoundLongLeftIcon,
  JobconfigBindingPerfectBoundLongRightIcon,
  JobconfigBindingPerfectBoundShortLeftIcon,
  JobconfigBindingPerfectBoundShortRightIcon,
} from 'components/Icons';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxRadioProps } from 'components/RevxRadio';
import { BINDING_EDGE_ENUM } from 'domains/jobconfigDomain';
import { useMemo } from 'react';
import { ConfigSvcProps } from '..';
import CommonJobSvcOption from '../common/CommonJobSvcOption';

const PerfectBound = (props: ConfigSvcProps) => {
  const { id, jobOptionSvc } = props;
  const svcOption = useMemo(() => {
    return {
      bindingEdge: jobOptionSvc.options.find(
        (option) => option.label === 'Binding Edge'
      ),
      otherOption: jobOptionSvc.options.filter(
        (option) => option.label !== 'Binding Edge'
      ),
    };
  }, [jobOptionSvc]);
  const bindingPerfectBoundRadioProps: RevxRadioProps = {
    outSideRevxLayoutProps: {
      align: 'bottom',
      justify: 'left',
      className:
        'jobconfig-jobOption-content-outSideOption jobconfig-jobOption-content-binding',
    },
    inSideRevxLayoutProps: {
      align: 'center',
      className: 'jobconfig-jobOption-content-inSideOption',
    },
    iconSequence: 'last',
    options: [
      {
        value: BINDING_EDGE_ENUM['Long Edge'],
        children: (
          <RevxFlexLayout direction="column">
            <RevxFlexLayout align="bottom">
              <JobconfigBindingPerfectBoundLongLeftIcon
                style={{ width: 80, height: 106, marginRight: 28 }}
              />
              <JobconfigBindingPerfectBoundLongRightIcon
                style={{ width: 106, height: 80 }}
              />
            </RevxFlexLayout>
            <label>Long-edge</label>
          </RevxFlexLayout>
        ),
      },
      {
        value: BINDING_EDGE_ENUM['Short Edge'],
        children: (
          <RevxFlexLayout direction="column">
            <RevxFlexLayout align="bottom">
              <JobconfigBindingPerfectBoundShortLeftIcon
                style={{ width: 80, height: 106, marginRight: 28 }}
              />
              <JobconfigBindingPerfectBoundShortRightIcon
                style={{ width: 106, height: 80 }}
              />
            </RevxFlexLayout>
            <label>Short-edge</label>
          </RevxFlexLayout>
        ),
      },
    ].filter((item) => svcOption?.bindingEdge?.values.includes(item.value)),
  };
  return (
    <>
      <div className="jobconfig-jobOption-content-title">Perfect Bound</div>
      <div className="jobconfig-jobOption-content-subTitle">Binding</div>
      <RevxFlexLayout>
        <Form.Item name={[id, 'Binding Edge']}>
          <RevxRadio {...bindingPerfectBoundRadioProps} />
        </Form.Item>

        <CommonJobSvcOption
          {...props}
          customerOptions={svcOption?.otherOption}
        />
      </RevxFlexLayout>
      <div className="jobconfig-jobOption-content-border"></div>
    </>
  );
};

export default PerfectBound;
